export const findTickTitle = (data, key) =>
  data.find((item) => item.xGroupId === Number(key)).xGroup;

export const findTextXCollisions = (data, nestedData, width) => {
  const availableTextWidth = width / nestedData.length;
  let longestKeyLength = 0;

  for (const item of nestedData) {
    if (findTickTitle(data, item.key).length > longestKeyLength) {
      longestKeyLength = findTickTitle(data, item.key).length;
    }
  }

  const longestWidth = longestKeyLength * 4.3;

  return longestWidth > availableTextWidth ? longestWidth : 0;
};

export const findTextYCollisions = (highestYValue, height) => {
  if (highestYValue < 20) {
    const highest = highestYValue * 12;
    return highest > height ? highest - height : 0;
  }
  return 0;
};
